import type { StockerRobotState } from './stockerTypes';

type Listener = () => void;

/** Parked lifter — bottom of rail at load-port level, fork retracted. */
export const STOCKER_ROBOT_PARKED: StockerRobotState = {
  status: 'idle',
  carriageT: 0.04,
  carriageX: 0,
  forkLocalZ: 0,
  armExtendT: 0,
  forkMode: 'retracted',
  carryingFoup: false,
};

const robotById = new Map<string, StockerRobotState>();
const listeners = new Set<Listener>();

export const stockerTransferRobotStore = {
  get(id: string): StockerRobotState {
    return robotById.get(id) ?? STOCKER_ROBOT_PARKED;
  },

  set(id: string, state: StockerRobotState) {
    robotById.set(id, state);
    listeners.forEach((l) => l());
  },

  clear(id: string) {
    if (robotById.delete(id)) {
      listeners.forEach((l) => l());
    }
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
